import c from '../common';

export default {

  //Column
  "Time": "Time",

  "status": c.status.en,
  "used": "Used",

  "currency": "Currency",

  "amount": "Total Amount(CAD)",

  "download": c.download.en.uppercase,

  "discountName": c.discount.en.uppercase + " Name",
  "issueId": "Issue ID",
};